import axios from 'axios';
import { apiBase } from './apiBase';
import {
  GetFundScreenerDataPayloadType,
  GetFundScreenerDataResponseType,
  GetFundScreenerMinMaxPayloadType,
  GetFundScreenerMinMaxResponseType,
  FundCompanySearchItem,
  FundCompanySearchApiItem,
  FundClassificationApiItem,
  FundAssetTypeApiItem,
} from '../types/fundScreener.type';

const authHeaders = (token: string) => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${token}`,
});

// Thin wrappers over the fund screener BE endpoints — no FE-state shaping here.

export const getFundScreenerData = (
  payload: GetFundScreenerDataPayloadType,
  token: string,
): Promise<GetFundScreenerDataResponseType> => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiBase()}/fund/screener/criteria/result`, payload, {
        headers: authHeaders(token),
      })
      .then((res) => {
        if (res.data?.data) resolve(res.data.data);
        else reject(new Error('Empty fund screener result response'));
      })
      .catch((err) => reject(err));
  });
};

export const getFundScreenerMinMax = (
  payload: GetFundScreenerMinMaxPayloadType,
  token: string,
): Promise<GetFundScreenerMinMaxResponseType> => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiBase()}/fund/screener/criteria/minmax`, payload, {
        headers: authHeaders(token),
      })
      .then((res) => {
        if (res.data?.data) resolve(res.data.data);
        else reject(new Error('Empty fund screener minmax response'));
      })
      .catch((err) => reject(err));
  });
};

export const getFundClassifications = (
  market: string,
  token: string,
): Promise<FundClassificationApiItem[]> => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${apiBase()}/fund/screener/classifications`, {
        params: { market },
        headers: authHeaders(token),
      })
      .then((res) => {
        if (res.data?.data) resolve(res.data.data);
        else reject(new Error('Empty fund screener classifications response'));
      })
      .catch((err) => reject(err));
  });
};

export const getFundAssetTypes = (
  market: string,
  token: string,
): Promise<FundAssetTypeApiItem[]> => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${apiBase()}/fund/screener/asset-types`, {
        params: { market },
        headers: authHeaders(token),
      })
      .then((res) => {
        if (res.data?.data) resolve(res.data.data);
        else reject(new Error('Empty fund screener asset-types response'));
      })
      .catch((err) => reject(err));
  });
};

export const getFundCompanyName = (
  keyword: string,
  market: string,
  token: string,
  pageNo = 1,
  pageSize = 20,
): Promise<FundCompanySearchItem[]> => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${apiBase()}/fund/mgmt/company/search`, {
        // Without `market`, results aren't scoped to the widget's market.
        params: { keyword, market, pageNo, pageSize },
        headers: authHeaders(token),
      })
      .then((res) => {
        const datalist: FundCompanySearchApiItem[] | undefined =
          res.data?.data?.datalist;
        if (datalist) {
          resolve(datalist.map((item) => ({ value: item.name, label: item.name })));
        } else {
          reject(new Error('Empty fund management company search response'));
        }
      })
      .catch((err) => reject(err));
  });
};
